import { __assign } from 'tslib';

var vineGreen = {
  20: "#92C136",
  40: "#85BA1D",
  60: "#77B204",
  80: "#6CA300" // Darker shade
};

var mofoColors = {
  white: "#ffffff",
  fieldBackground: "#f5f7fa",
  background: "#eaecef",
  almostWhite: "#f7f8fa",
  divider: "#e2e2e2",
  disabled: "#d9d9d9",
  fieldBorder: "#e2e2e2",
  smurfette: "#e0f6ff",
  papaSmurf: "#1cb6f4",
  mystique: "#1392c5",
  neonGreen: "#cdff6b",
  mofoGreen: vineGreen[60],
  greenLantern: vineGreen[60],
  bubbly: "#fff2d4",
  liquidGold: "#d6a871",
  charlie: "#fca403",
  sunlit: "#fca403",
  clockwork: "#ff6d21",
  pinky: "#ff62a5",
  deal: "#d51c5c",
  redRedWine: "#9a0945",
  dorianGray: "#626468",
  darkMofo: "#232627",
  vader: "#131314",
  black: "#131314",
  riverBed: "#0072AD",
  sunsetOrange: "#FF5501",
  cellarBuff: "#F5D9B9",
  nightPickBlack: "#122122",
  chalkWhite: "#EEEEEE"
};
var themeColors = __assign({
  brand: mofoColors.mofoGreen,
  primary: mofoColors.mofoGreen,
  secondary: mofoColors.vader,
  mofoBrand: mofoColors.mofoGreen,
  mofoPrimary: mofoColors.mofoGreen,
  mofoSecondary: mofoColors.vader,
  vineGreen: vineGreen,
  text: {
    heading: mofoColors.vader,
    normal: mofoColors.dorianGray,
    button: mofoColors.vader
  }
}, mofoColors);
var breakpointValues = [0, 768, 980, 1200];
var fontSizes = [12, 14, 16, 18, 20, 24, 26, 28, 30, 32, 36, 40, 42, 48, 64, 96];
var baseTheme = {
  colors: __assign({}, themeColors),
  spaces: [0, 10, 16, 20, 30, 40, 60, 100],
  breakpoints: breakpointValues.map(function (value) {
    return "".concat(value, "px");
  }),
  mq: {
    min: {
      tablet: "(min-width: ".concat(breakpointValues[1] + 1, "px)"),
      desktop: "(min-width: ".concat(breakpointValues[2] + 1, "px)")
    },
    max: {
      mobile: "(max-width: ".concat(breakpointValues[1] - 1, "px)"),
      tablet: "(max-width: ".concat(breakpointValues[2] - 1, "px)")
    }
  },
  fonts: {
    heading: "\"DM Sans\", sans-serif",
    normal: "\"Graphik\", sans-serif",
    specialHeading: "\"TIMMONSNY\", sans-serif"
  },
  fontSizes: fontSizes,
  letterSpacings: {
    tight: "-0.025em",
    normal: "0em",
    wide: "0.025em"
  },
  lineHeights: {
    none: "1",
    short: "1.25",
    normal: "1.5",
    tall: "1.625"
  }
};
var defaultToolkitTheme = __assign({}, baseTheme);

export { baseTheme, defaultToolkitTheme };
//# sourceMappingURL=defaultToolkitTheme.js.map
